import { memo } from 'react';
import cls from 'classnames';

import styles from './AltSkuField.module.css';

interface AltSkuFieldProps {
  value: string;
  className?: string;
}

function AltSkuField(props: AltSkuFieldProps) {
  const { value, className } = props;

  return (
    <p aria-label="Alternative SKU" className={cls(styles.altSkuField, className)} title={value}>
      {value}
    </p>
  );
}

export default memo(AltSkuField);
